//import _ from 'lodash';

import * as constants from './Career.constants';
import * as services from './Career.service';

const state = {
  plan: {},

  isRequest: false,
};

const mutations = {
  [constants.GET_WEB_TREE_PLAN_SUCCESS](state, plan) {
    if (undefined !== plan && null !== plan) {
      state.plan = plan;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, isRequest) {
    state.isRequest = isRequest;
  },
};

const actions = {
  async getWebTreePlan({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getWebTreePlan(payload);
    commit(constants.GET_WEB_TREE_PLAN_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  plan: (state) => state.plan,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
